import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { formatDate } from '../../../../services/dateUtilityFunctions';
import { SALE_STATUS } from '../../proptype/commissionProp';
import CloseIcon from '../../../../commonComponents/icons/icon/CloseIcon';

function SaleHistory(props) {
  const { t, onClose, history, status, paymentDate, saleStatus } = props;

  const getSaleStatus = useCallback(
    historyItem => {
      let translation;
      let badge;
      switch (historyItem.status) {
        case SALE_STATUS.PAID:
          translation = t('commissions.user.sale.status.paid');
          badge = 'sale-bg-paid';
          break;
        case SALE_STATUS.ON_GOING:
          translation = t('commissions.user.sale.status.on_going');
          badge = 'sale-bg-ongoing';
          break;
        case SALE_STATUS.RECEIVED:
          translation = t('commissions.user.sale.status.received');
          badge = 'sale-bg-received';
          break;
        case SALE_STATUS.CANCELED:
          translation = t('commissions.user.sale.status.canceled');
          badge = 'sale-bg-canceled';
          break;
        case SALE_STATUS.REJECTED:
          translation = t('commissions.user.sale.status.rejected');
          badge = 'sale-bg-canceled';
          break;
        case SALE_STATUS.DISABLED:
          translation = t('commissions.user.sale.status.disabled');
          badge = 'sale-bg-canceled';
          break;
        default:
          translation = '-';
          badge = '';
          break;
      }
      return { translation, badge };
    },
    [t, history],
  );

  return (
    <div className="sidebar-section">
      <button type="button" onClick={onClose} className="btn-close">
        <CloseIcon />
      </button>
      <div className="item">
        {status && (
          <div className="status-container">
            <span className="commission-modal-label">
              {t('commission.modal.sale.status')}
            </span>
            <div
              className={`commission-modal-value sale-status sale-bg ${saleStatus.badge}`}
            >
              <span>{saleStatus.translation}</span>
            </div>
          </div>
        )}
        <div className="date-container">
          <span className="commission-modal-label">
            {t('weelodge.modal.paymentDate')}
          </span>
          <div className="commission-modal-value">{paymentDate}</div>
        </div>
      </div>
      <div className="history-wrapper">
        <h5>{t('weelodge.modal.history')}:</h5>
        {history?.length > 0 ? (
          history?.map(historyItem => (
            <div className="history-item" key={historyItem.date}>
              <div className="history-item-status">
                <div
                  className={`sale-bg sale-container-bg ${
                    getSaleStatus(historyItem).badge
                  }`}
                />
                <p className="history-item-status-text">
                  {getSaleStatus(historyItem).translation}
                </p>
              </div>
              <p className="history-item-date">
                {formatDate(historyItem?.date, 'DD MMM, YYYY')}
              </p>
            </div>
          ))
        ) : (
          <p className="no-data-hint">{t('no.history.data')}</p>
        )}
      </div>
    </div>
  );
}

SaleHistory.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  history: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  ).isRequired,
  status: PropTypes.string.isRequired,
  paymentDate: PropTypes.string.isRequired,
  saleStatus: PropTypes.shape({
    badge: PropTypes.string,
    translation: PropTypes.string,
  }).isRequired,
};
export default translate(SaleHistory);
